export const InstrumentProcessType = {
  IDLE: 'idle',
  PROTOCOL_EXECUTION: 'runningProtocol',
  AUTO_TRAY_CALIBRATION: 'runningAutoCalibration',
  MANUAL_RETEACH_PLATE: 'runningManualReteach',
  PLATE_DEFINITION: 'runningPlateDefinition',
  BACKUP_AND_RESTORE_DATA: 'runningBackupAndRestoreData',
};

export const _doNotUse = {};
